export default {
  customer: {
    dialog: {
      whatsApp: {
        needSupport: '需要帮助？打开 WhatsApp 扫码获得技术支持',
        saveTheQR: '保存二维码到相册'
      },
      wechat: {
        needSupport: '需要帮助？',
        withWeChat: '打开微信扫码获得技术支持',
        saveTheQR: '保存二维码到相册'
      },
      facebook: {
        needSupport: '需要帮助？',
        copyAccount: '复制客服账号',
        FacebookToContact: '打开 Facebook Messenger 搜索 lavamusicofficial 获得技术支持'
      }
    }
  },
  chat_online: '在线客服',
  wechat: '微信',
  lava_support_team: '拿火客服团队'
}
